import { Type } from "class-transformer";

export class ConversationSummaryDto {
  conversationId: string;
  firstQuestion: string;

  @Type(() => Date)
  lastMessageAt: Date;

  messageCount: number;
}
